import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_CON_REMITO } from '../../../../../config/tables'

function TablaCamionesConRemitoView () {
  return (
    <div style={{ margin: '8px auto' }}>
      <MuiTable id={TABLA_CAMIONES_CON_REMITO} />
    </div>
  )
}

export default TablaCamionesConRemitoView
